module.exports = __webpack_public_path__ + "b21c8eaf5ecb365b5d954a02798dc1fa.woff";